export default __webpack_public_path__ + "static/media/javascript-02.86eac138.png";